const userMessages = {
  errors: {
    genericAuctionsFetch: 'There was a problem retrieving auctions. Please check your network and try again.',
    canceledFetch: 'Request canceled due to being idle or offline',
  },
};

export default userMessages;
